import { render } from "./OrderSummary.vue?vue&type=template&id=7a131eb4&scoped=true"
import script from "./OrderSummary.vue?vue&type=script&lang=js"
export * from "./OrderSummary.vue?vue&type=script&lang=js"

import "./OrderSummary.vue?vue&type=style&index=0&id=7a131eb4&scoped=true&lang=scss"

import exportComponent from "/srv/sites/eservice.talronbatt.co.il/api/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a131eb4"]])

export default __exports__